import {
  DocumentTypeDto,
  SubscriberDocumentsResponseDto,
} from 'enrollment/features/ToDoList/types';
import { DependentDto } from 'theSource/features/FamilyMembers/types';
import { DocRequestDetails } from '../components';
import { ProfileState } from 'enrollment/features/Profile/services';

export const getDocName = (docTypes: DocumentTypeDto[], docTypeId?: number) => {
  const docType = docTypes.find((type) => type.id === docTypeId);
  return docType?.name || null;
};

export const mapSubscriberRequestdetails = (
  data: SubscriberDocumentsResponseDto,
  subscriber: ProfileState
) => {
  const value = data && data?.document_requests?.subscriber?.map((item) => {
    // doc type ids can either be a string or number so we should enforce one type
    const docTypeIds = item?.org_subscriber_document_type_ids?.map((docTypeId) => String(docTypeId));
    return {
      ...item,
      org_subscriber_document_type_ids: docTypeIds,
    };
  });

  const profileDetails: DependentDto = {
    id: subscriber.id,
    first_name: subscriber.first_name,
    middle_name: subscriber.middle_name,
    last_name: subscriber.last_name,
    dependent_profile: subscriber.subscriber_profile,
  };

  return {
    key: String(profileDetails.id),
    documentRequests: value,
    profileDetails,
    documentTypes: data?.document_types,
  } as DocRequestDetails;
};

export const mapDependentDocRequestDetails = (
  data: SubscriberDocumentsResponseDto,
  dependents: DependentDto[]
) => {
  if (data?.document_requests.dependents) {
    return Object?.entries(data?.document_requests.dependents)?.map(
      ([key, value]) => {
        const dependentDetails = dependents?.find(
          (d) => d.id === parseInt(key) || d.public_id === parseInt(key)
        );

        let profileDetails: DependentDto | undefined = undefined;

        const documentRequests = value?.map((item) => {
          // doc type ids can either be a string or number so we should enforce one type
          const docTypeIds = item?.org_subscriber_document_type_ids?.map((docTypeId) => String(docTypeId));
          return {
            ...item,
            org_subscriber_document_type_ids: docTypeIds,
          };
        });

        // only active dependent details will be displayed
        if (dependentDetails !== undefined) {
          profileDetails = {
            id: dependentDetails.id,
            first_name: dependentDetails.first_name,
            middle_name: dependentDetails.middle_name,
            last_name: dependentDetails.last_name,
            dependent_profile: dependentDetails.dependent_profile,
          };
        }

        return {
          key,
          documentRequests: documentRequests,
          profileDetails,
          documentTypes: data?.document_types,
        } as DocRequestDetails;
      }
    );
  }

  return [
    {
      key: '0',
      documentRequests: {},
      profileDetails: {},
      documentTypes: data?.document_types,
    },
  ] as DocRequestDetails[];
};
